module.exports = __webpack_public_path__ + "img/logo-swipe.ade7bc93.svg";